import { getRealEstatePipelineRun } from "./midpointApi";

const TERMINAL_STATUSES = new Set(["SUCCESS", "FAILED", "CANCELLED"]);
const DEFAULT_INTERVAL_MS = 4000;
const DEFAULT_MAX_ATTEMPTS = 90;

export function pollRunUntilComplete(runId, options = {}) {
  const {
    intervalMs = DEFAULT_INTERVAL_MS,
    maxAttempts = DEFAULT_MAX_ATTEMPTS,
    onUpdate,
    signal,
  } = options;

  return new Promise((resolve, reject) => {
    if (!runId) {
      reject(new Error("runId is required for polling"));
      return;
    }

    let attempts = 0;
    let timerId = null;
    let consecutiveErrors = 0;

    const cleanup = () => {
      if (timerId) {
        clearInterval(timerId);
        timerId = null;
      }
    };

    const poll = async () => {
      if (signal?.aborted) {
        cleanup();
        reject(new Error("Polling cancelled"));
        return;
      }

      attempts += 1;

      try {
        const data = await getRealEstatePipelineRun(runId);
        const run = data?.run;

        if (!run) {
          consecutiveErrors += 1;
        } else {
          consecutiveErrors = 0;
          onUpdate?.(run);

          if (TERMINAL_STATUSES.has(run.status)) {
            cleanup();
            resolve(run);
            return;
          }
        }
      } catch (error) {
        consecutiveErrors += 1;

        if (consecutiveErrors >= 3) {
          cleanup();
          reject(error);
          return;
        }
      }

      if (attempts >= maxAttempts) {
        cleanup();
        reject(new Error("Run polling timed out before completion."));
      }
    };

    poll();
    timerId = setInterval(poll, intervalMs);

    if (signal) {
      signal.addEventListener(
        "abort",
        () => {
          cleanup();
          reject(new Error("Polling cancelled"));
        },
        { once: true }
      );
    }
  });
}
